import { RestRequest, } from '@Utils/rest';

export const unsubscribeEntity = async (table: string, recognizer: string = 'main'): Promise<any> => {
  return RestRequest.put<{sid: string; table: string; recognizer: string}, boolean>('/global/unsubscribe/entity', {
    sid: global.socketId,
    table,
    recognizer,
  });
};
